import React, { useEffect } from 'react';
import { Button } from '../components/ui/button';
import { ArrowRight, ExternalLink } from 'lucide-react';

const Workbook = () => {
  useEffect(() => {
    document.title = 'Parent Workbook - Sparklyt';
  }, []);

  const handleGetToolkit = () => {
    window.open('https://tagmango.com/web/checkout/69b2bf14b698550de7df8c3e', '_blank', 'noopener,noreferrer');
  };

  return (
    <div className="workbook-page">
      {/* Section 1 - Phase Announcement */}
      <section className="section-padding">
        <div className="container">
          <div className="hero-content">
            <p className="phase-label">PHASE 1 - NOW OPEN</p>
            <h1 className="hero-large">
              Before the Crossroads.
            </h1>
            <div className="hero-subtitle body-large" style={{ maxWidth: '800px', margin: '0 auto' }}>
              <p>
                We started with parents. Before a child can find direction, the parent needs to examine what they are bringing into the conversation...the beliefs, the pressures, the assumptions made without realising it. That is what Phase 1 is designed for.
              </p>
              <p style={{ marginTop: '24px' }}>
                This is not a career quiz. It is a structured workbook built for parents who are ready to slow down, observe more, and ask better questions.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Section 2 - What the workbook covers */}
      <section className="section-padding-small bg-secondary">
        <div className="container">
          <h2 className="heading-1" style={{ textAlign: 'center', marginBottom: '48px' }}>What's inside</h2>
          <div className="grid-two-column">
            <div className="feature-card">
              <h3 className="heading-2">Reflection</h3>
              <p className="body-large">
                Examine the beliefs and pressures you bring to your child's future before they shape every decision.
              </p>
            </div>
            <div className="feature-card">
              <h3 className="heading-2">Observation</h3>
              <p className="body-large">
                Learn to notice what your child's energy, attention, and instincts are already telling you.
              </p>
            </div>
            <div className="feature-card">
              <h3 className="heading-2">Exploration</h3>
              <p className="body-large">
                Eight structured experiences designed to surface genuine interest through doing, not declaring.
              </p>
            </div>
            <div className="feature-card">
              <h3 className="heading-2">Conversations</h3>
              <p className="body-large">
                A practical guide to shifting from questions that create pressure to ones that open possibility.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Section 3 - Get the workbook */}
      <section className="section-padding">
        <div className="container">
          <div className="pricing-section">
            <h2 className="heading-1" style={{ textAlign: 'center' }}>The Parent Toolkit</h2>
            <p className="body-regular text-secondary" style={{ textAlign: 'center', marginTop: '12px' }}>
              Phase 1 - Parent Workbook · PDF · Instant download
            </p>
            <div className="price-display">
              ₹1099
            </div>
            <p className="body-small text-secondary" style={{ textAlign: 'center', marginTop: '12px' }}>
              A one-time purchase. Yours to keep.
            </p>
            <div style={{ display: 'flex', justifyContent: 'center', marginTop: '40px' }}>
              <Button 
                className="btn-primary btn-toolkit"
                onClick={handleGetToolkit}
              >
                Get the Workbook
                <ArrowRight className="ml-2" size={16} />
              </Button>
            </div>
          </div>
        </div>
      </section>

      {/* Section 4 - What you get after purchasing */}
      <section className="section-padding-small bg-secondary">
        <div className="container">
          <div className="content-section">
            <h2 className="heading-1">What comes with it</h2>
            <div className="deliverables-list">
              <div className="deliverable-item">
                <h3 className="heading-3">The Workbook</h3>
                <p className="body-large">
                  The complete Before the Crossroads PDF with four chapters, an exploration log format, and a closing reflection. Designed to be worked through over four to six weeks.
                </p>
              </div>
              <div className="deliverable-item">
                <h3 className="heading-3">Sparklyt Parent Circle</h3>
                <p className="body-large">
                  An invite to a live group session on Google Meet where all parents doing the workbook come together to share what they noticed, what surprised them, and what shifted. Not a webinar. A real conversation.
                </p>
              </div>
              <div className="deliverable-item">
                <h3 className="heading-3">Early Access to Phase 2</h3>
                <p className="body-large">
                  When the next phase of Sparklyt opens, you are first. At a price that reflects your early trust in what we are building.
                </p>
              </div>
              <div className="deliverable-item">
                <h3 className="heading-3">Future Toolkits and Direct Updates</h3>
                <p className="body-large">
                  Everything Sparklyt builds next comes to you before it goes anywhere else.
                </p>
              </div>
            </div>
            <p className="body-small text-secondary" style={{ marginTop: '48px', maxWidth: '700px' }}>
              After purchasing, visit www.sparklyt.com and click Request Early Access to join the Sparklyt waitlist. That is where Parent Circle dates, Phase 2 access, and all updates are coordinated.
            </p>
          </div>
        </div>
      </section>

      {/* Section 5 - Phase 2 teaser */}
      <section className="section-padding cta-section">
        <div className="container">
          <div className="cta-content">
            <h2 className="hero-medium">Phase 2 is coming...</h2>
            <div className="content-spacing" style={{ maxWidth: '700px', margin: '32px auto 0' }}>
              <p className="body-large" style={{ textAlign: 'center' }}>
                Phase 1 prepares the parent. Phase 2 brings the parent and child into the process together through guided exploration, structured conversations, and a framework built around identity, not prediction.
              </p>
              <p className="body-large" style={{ textAlign: 'center', marginTop: '24px' }}>
                Parents who complete Phase 1 will be first to know when it opens.
              </p>
              <p className="body-small text-secondary" style={{ textAlign: 'center', marginTop: '24px' }}>
                Stay tuned.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Workbook;
